module.exports = __webpack_public_path__ + "img/lg_ring_g_s_null_0@3x.9af90a37.png";